import { BREAKPOINT_PADDING_VAR, mediaBreakpointUp } from '@/styles/layout/utils';
import { FONT_WEIGHTS } from '@/styles/typography';
import { customTextSize } from '@/styles/typography/utils';
import styled from 'styled-components';

const Wrapper = styled.div`
  ${mediaBreakpointUp('desktop')} {
    display: grid;
    grid-template-columns: repeat(18, 1fr);
    column-gap: 20px;
  }
`;

const Heading = styled.h2`
  ${customTextSize(16, 21)}
  font-weight: ${FONT_WEIGHTS.BOLD};
  text-align: center;
  margin-bottom: 30px;

  ${mediaBreakpointUp('tablet')} {
    ${customTextSize(24, 30)}
    font-weight: ${FONT_WEIGHTS.SEMIBOLD};
  }

  ${mediaBreakpointUp('desktop')} {
    ${customTextSize(32, 38)}
    grid-column: 3 / -3;
    margin-bottom: 40px;
  }

  ${mediaBreakpointUp('desktopWide')} {
    ${customTextSize(49, 58)}
    margin-bottom: 50px;
  }
`;

const ProductImage = styled.div`
  position: relative;
  width: calc(100% + (${BREAKPOINT_PADDING_VAR} * 1.5));
  left: calc(${BREAKPOINT_PADDING_VAR} * -0.6);

  ${mediaBreakpointUp('tablet')} {
    width: 100%;
    left: 0;
  }

  ${mediaBreakpointUp('desktop')} {
    grid-column: 2 / -2;
    width: calc(100% + 40px);
    left: -20px;
  }

  ${mediaBreakpointUp('desktopWide')} {
    grid-column: 1 / -1;
    width: 100%;
    left: 0;
  }
`;

const productOverviewComponents = {
  Wrapper,
  Heading,
  ProductImage,
};

export default productOverviewComponents;
